/* import __COLOCATED_TEMPLATE__ from './state-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();